module.exports = __webpack_public_path__ + "img/icon-07.58f2a710.png";